import React, {useCallback, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import ExtraIcon from "../../../../assets/extra.png";
import EditIcon from '../../../../assets/edit.svg'
import {
	EmptyState,
	Loader,
	Table,
	DropDown, Modal, Button, SearchInput, Toast,
} from '@kaleyra/emmy';

import cn from 'classnames';
import {Helmet} from "react-helmet";
import AddIcon from "../../../../assets/AddWhite.svg";
import {debounce} from "lodash";
import {useHistory} from "react-router-dom";

export type MapStateType = {
	data: any;
	page: number;
	total: number;
	inProgress: boolean;
	appliedFilters: Record<string, any>;
	globalTotal: number;
	paginationInProgress: boolean;
};

export type DispatchPropsType = {
	onPaginate: () => void;
	initializeAndLoadData: (
		filters?: Record<string, any>,
		searchTerm?: string,
		dynamicUrlData?:string
	) => void;
	removeInstance: () => void;
	openAddModal: (params:any) => void;
	openEditCredentialModal: (params:any) => void;
	openChangePasswordModal: (params:any) => void;
	openRenameModal: (params:any) => void;
	onSearchTextChange: (searchText: string) => void;
	removeCliDropdownInstance : () => void;
	removeUserGroupInstance : () => void;
	onDeleteCredential: ( filters:any,dynamicUrlData: string, keyForIdentifier:string, cb?:(res: any, success: boolean)=> void ) => void;
	editUserGroup: ( reqData:any,keyForIdentifier:string, dynamicUrl:string, cb?:(res: any, success: boolean)=> void ) => void;
};
type params = {
	match:any
}
type PropsType = MapStateType & DispatchPropsType & params;

const SipCredential: React.FC<PropsType> = (
	{
		data,
		page,
		total,
		inProgress,
		onPaginate,
		initializeAndLoadData,
		globalTotal,
		paginationInProgress,
		removeInstance,
		openAddModal,
		openChangePasswordModal,
		openEditCredentialModal,
		openRenameModal,
		removeCliDropdownInstance,
		onSearchTextChange,
		onDeleteCredential,
		editUserGroup,
		removeUserGroupInstance
	}) => {
	const { t } = useTranslation();
	const history:any = useHistory();
	if(!history?.location?.state?.credential_group_id) history.push("/channels/voice/sip-user-group");
	const [userGroupData,setUserGroupData] = useState<Record<string, any>>({});
	const [selectedCredential, setSelectedCredential] = useState<any>({});
	const [deleteCredential, setDeleteCredential] = useState(false);
	// const [editSoundModal, setEditSoundModal] = useState(false);
	const [searchText, setSearchText] = useState('');

	React.useEffect(() => {
		if(!history?.location?.state?.credential_group_id) return history.push("/channels/voice/sip-user-group");
		setUserGroupData(history.location.state);
		initializeAndLoadData(
			{credential_group_id:history.location.state.credential_group_id},
			"username"
		);
		return () => {
			removeInstance();
			removeCliDropdownInstance();
			removeUserGroupInstance();
		}
	}, []);

	const handleCredentialDelete = useCallback( (id: string) => {
		onDeleteCredential({credential_group_id:history.location.state.credential_group_id},id,"credential_id",
			(res:any,success:boolean)=>{
				if(success) Toast(t('KLR00489'),'success');
				else if(res?.data?.message) Toast(res?.data?.message,'error');
			});
	},[]);
	const renderDeleteCredentialModal = useCallback( () => {
		return (
			<Modal
				title={t('KLR00453')}
				body={t('KLR00454',{credentialName:selectedCredential?.username||""})}
				visible={deleteCredential}
				footer={
					<div>
						<span style={{ marginRight: '1rem' }}>
							<Button
								// disabled={soundOpInit}
								type="tertiary"
								onClick={() => setDeleteCredential(false)}
							>
								{t('mainCancel')}
							</Button>
						</span>
						<Button
							// disabled={soundOpInit}
							type="danger"
							onClick={() => {
								handleCredentialDelete(selectedCredential.credential_id);
								setDeleteCredential(false);
							}}
						>
							{t('mainYesDelete')}
						</Button>
					</div>
				}
			/>
		);
	},[deleteCredential,setDeleteCredential]);
	const getColumns = () => {
		return [
			{
				accessor: 'username',
				header: t('KLR00444'),
				width: '45%',
			},
			{
				accessor: 'cli',
				header: t('KLR00479'),
				width: '45%',
			},
			{
				header: t(''),
				accessor: '',
				width:"10%",
				Cell: (tableData: any) => {
					const { original } = tableData;
					return (
						<DropDown
							items={[
								{
									label: t('mainEdit'),
									value: 'edit',
								},{
									label: t('KLR00455'),
									value: 'changePassword',
								},{
									label: t('mainDelete'),
									value: 'delete',
								},
							]}
							action={(operation: any) => {
								if (operation === 'delete') {
									setSelectedCredential(original);
									setDeleteCredential(true);
								} else if (operation === 'edit') {
									openEditCredentialModal({
										selectedCredential:original,
										credentialGroupId:userGroupData.credential_group_id,
									});
								}else if(operation === 'changePassword'){
									openChangePasswordModal({
										selectedCredential:original,
										credentialGroupId:userGroupData.credential_group_id
									});
								}
							}}
							placement="bottom"
							trigger={['click']}
						>
							<img
								src={ExtraIcon}
								id={original?.id}
								className={Styles.dotsImg}
							/>
						</DropDown>
					);
				},
			},
		];
	};

	const handleRenameUserGroup = (title:string)=>{
		setUserGroupData(prevState => ({ ...prevState, title }));
		editUserGroup(
			{
				credential_group_name : title
			},
			"credential_group_id",
			userGroupData.credential_group_id,
			(res:any,success:boolean)=>{
				if(success){
					setUserGroupData((prevState:Record<string, any>) => {
						return {
							...prevState,
							credential_group_name: res.data.credential_group_name
						};
					});
					Toast(t('KLR00487'),'success');
				}
				else if(res?.data?.message) Toast(res?.data?.message,'error');
			}
			);
	}
	const getTopBar = () => {
		return (
			<>
				<span className={Styles.heading}>
					{`${userGroupData.credential_group_name}`}
					<span className={Styles.editIcon} onClick={()=>openRenameModal({
						title:userGroupData?.credential_group_name,
						handleRenameUserGroup
					})}>
						<img src={EditIcon}/>
					</span>
				</span>
			</>
		)
	}

	const debouncedChange = React.useCallback(
		debounce((value:any = "") => {
			onSearchTextChange(value);
		}, 400),
		[userGroupData]
	);

	return (
		<div className={Styles.container}>
			<Helmet>
				<title>{t('KLR00437')}</title>
			</Helmet>
			{ getTopBar() }
			{globalTotal > 0 && (
				<>
					<div className={cn(Styles.searchContainer)}>
						<SearchInput
							className={Styles.searchInput}
							eachChar={true}
							placeholder={t('mainSearch')}
							label={t('mainSearch')}
							searchStr={searchText}
							onChange={(value: any) => {
								setSearchText(value);
								debouncedChange(value);
							}}
							autoComplete="new-password"
						/>

						<span
							className={Styles.addBtn}
						>
									<Button
										type="primary"
										onClick={() =>
											openAddModal({
												userGroupData,
												onlyAddCredential:true
											})
										}
										icon={<img src={AddIcon} />}
										iconPosition="left"
									>
										{t('KLR00456')}
									</Button>
								</span>
					</div>
				</>
			)}
		{ (inProgress || globalTotal == null || globalTotal == undefined) ? <Loader/>	:
			(
				<>
					{ (globalTotal === 0)?
					<EmptyState
						bordered
						smallBorder={true}
						showButton={false}
						logStyle={true}
						labelForLogStyle={t('KLR00478')}
					/> :
					<Table
						columns={getColumns()}
						data={data}
						page={page + 1}
						pageSize={25}
						manual
						onPaginate={onPaginate}
						total={total}
						inProgress={paginationInProgress}
						labelForNoResult={t('KLR00477')}
						labelForNoResultDesc={t('KLR00478')}
						rowClassName={Styles.SATable}
					/>}
				</>
			)
		}
			{renderDeleteCredentialModal()}
		</div>
	);
};

export default SipCredential;
